module.exports = __webpack_public_path__ + "img/corehcs_dashboard3.70520a2c.png";